import { Grid } from "antd";

export const useBreakpoint = Grid.useBreakpoint;
export default useBreakpoint;
